import type { ComponentChildren, JSX, LabelHTMLAttributes } from "preact";
import { classNames } from "@gss/common/classNames";
import { Help } from "./icons";

export interface LabelProps extends LabelHTMLAttributes {
    title?: string;
    bold?: boolean;
    noTitleIcon?: boolean;
    className?: string;
    children: ComponentChildren;
}

export function Label({
    title,
    noTitleIcon,
    bold,
    className,
    children,
    ...rest
}: LabelProps): JSX.Element {
    return (
        <label
            {...rest}
            className={classNames(bold && "fw-bold", className)}
            title={title}
        >
            {children}
            {title != null && !noTitleIcon && <Help className="ms-1" />}
        </label>
    );
}
